// Module
var code = "<h2 id=\"endorsers-co-signers--co-makers\">Endorsers, Co-signers, &amp; Co-makers</h2> <p>Find out the responsibilities you have as an endorser, co-signer, or co-maker.</p> ";
// Exports
export default code;